import { render } from "./TrainingLayoutView.vue?vue&type=template&id=5d07fee0"
import script from "./TrainingLayoutView.vue?vue&type=script&lang=js"
export * from "./TrainingLayoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__